import useSpaceliftLoginsCookie from "hooks/useSpaceliftLoginsCookie";
import { AllowedRegion, createAccountNameWithRegion, getRegion } from "utils/region";

type UseAvailableLoginsOptions = {
  accountName: string;
};

const useAvailableLogins = ({ accountName }: UseAvailableLoginsOptions) => {
  const { cookieLoginsWithRegion } = useSpaceliftLoginsCookie();
  const currentRegion = getRegion();
  const currentLogin = createAccountNameWithRegion(accountName, currentRegion);
  const logins = cookieLoginsWithRegion.filter(
    (item: { accountName: string; region: AllowedRegion }) =>
      item.accountName !== currentLogin && item.region !== currentRegion
  );

  const hasMultipleRegions = new Set(cookieLoginsWithRegion.map(({ region }) => region)).size > 1;

  return {
    logins,
    hasAvailableLogins: logins.length > 0,
    hasMultipleRegions,
  };
};

export default useAvailableLogins;
